import {
  Chart as ChartJS,
  CategoryScale,
  Tooltip,
  Legend,
  ArcElement,
  ChartOptions,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import classNames from "classnames";
import { FC } from "react";
import { Doughnut } from "react-chartjs-2";

import styles from "./DoughnutChartIssues.module.scss";

import { DataItem } from "../../../types/previewTemplate";
import { Description } from "../../Description";

ChartJS.register(CategoryScale, Tooltip, Legend, ArcElement, ChartDataLabels);

interface IProps {
  dataList?: DataItem[];
  className?: string;
  title?: string;
  legendTitle?: string;
  radius?: number;
}

export const DoughnutChartIssues: FC<IProps> = ({
  dataList,
  className,
  title,
  legendTitle,
  radius = 93,
}) => {
  const innerDiameter = 45;
  const outerDiameter = 100;

  const options: ChartOptions<"doughnut"> = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: `${(innerDiameter / outerDiameter) * 100}%`,
    radius: radius,
    circumference: 360,
    clip: 33,
    plugins: {
      legend: {
        title: {
          display: true,
          text: legendTitle,
          position: "start",
          color: "#000000",
          padding: 0,
          font: {
            size: 14,
            weight: 500,
          },
        },
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: true,
          boxWidth: 20,
          boxHeight: 20,
          padding: 24,
          color: "black",
        },
      },

      datalabels: {
        color: "#000000",
        font: {
          weight: 400,
        },
        formatter: function (value: number, context: any) {
          const dataset = context.chart.data.datasets[context.datasetIndex];
          const total = dataset.data.reduce(
            (acc: number, curr: number) => acc + curr,
            0,
          );
          const percentage = ((value / total) * 100).toFixed(2);

          return `${value} (${percentage}%)`;
        },
        anchor: "end",
        align: "end",
        offset: 10,
        clip: false,
      },
    },
    elements: {
      arc: {
        borderWidth: 0,
        borderRadius: 0,
      },
    },
    layout: {
      padding: {
        bottom: 0,
      },
    },
  };

  const data = {
    labels: dataList?.map((item) => item.label),
    datasets: [
      {
        data: dataList?.map((item) => item.value),
        backgroundColor: dataList?.map((item) => item.color),
        borderColor: dataList?.map((item) => item.color),
      },
    ],
  };

  return (
    <div className={classNames(styles.root, className)}>
      <Description theme={"t3"}>{title}</Description>
      <div className={styles.dashBoardWrapper}>
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
};
